/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoContattoUpdateDTO
 */
export interface TipoContattoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoContattoUpdateDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the TipoContattoUpdateDTO interface.
 */
export function instanceOfTipoContattoUpdateDTO(value: object): value is TipoContattoUpdateDTO {
    return true;
}

export function TipoContattoUpdateDTOFromJSON(json: any): TipoContattoUpdateDTO {
    return TipoContattoUpdateDTOFromJSONTyped(json, false);
}

export function TipoContattoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoContattoUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function TipoContattoUpdateDTOToJSON(value?: TipoContattoUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'descrizione': value['descrizione'],
    };
}

